import axiosInstance from "../../utils/axiosInstance";
import {LAYER_ACTION_TYPES} from "../typesAction";


export const setLoading = () => {
    return {type: LAYER_ACTION_TYPES.LOAD_LAYER}
};

export const clearLoading = () => {
    return {type: LAYER_ACTION_TYPES.CLEAR_LOAD_LAYER}
};

export const clearLayerError = () => {
    return {type: LAYER_ACTION_TYPES.CLEAR_LAYER_ERRORS}
};

export const listLayers = (history, pagination, filters = {}, sorter) => async dispatch => {
    try {
        dispatch(setLoading());
        // Prepare all query parameters
        let queryParameters = {}
        Object.keys(filters).map(key => (
            queryParameters[key] = filters[key] == null ? filters[key] : filters[key][0])
        );
        if (sorter !== undefined) {
            queryParameters['sort'] = sorter['field']
            queryParameters['order'] = sorter['order'] === 'descend' ? 'desc' : 'asc'
        }
        if (pagination !== undefined) {
            queryParameters['offset'] = (pagination.current - 1) * pagination.pageSize
            queryParameters['max'] = pagination.pageSize
        }
        // Spread the parameters
        const params = {
            ...queryParameters
        };
        // Send request and get data
        const {data} = await axiosInstance(history, dispatch).get('/layer', {params});
        // Update state

        dispatch({
            type: LAYER_ACTION_TYPES.LIST_LAYER,
            payload: data
        });
        return data;
    } catch (err) {
        console.log(err);
        dispatch({
            type: LAYER_ACTION_TYPES.ERROR_LAYER,
            payload: err.message
        });
    }
};

export const addLayer = (history, layer, setLayerCreated) => async dispatch => {
    try {
        dispatch(setLoading());
        // Send request and get data
        const {data} = await axiosInstance(history, dispatch).post('/layer', layer);
        // Update state
        dispatch({
            type: LAYER_ACTION_TYPES.ADD_LAYER,
            payload: data
        });
        setLayerCreated(true);
    } catch (err) {
        console.log(err);
        const error = await err.response.data;
        dispatch({
            type: LAYER_ACTION_TYPES.ERROR_LAYER,
            payload: error
        });
    }
};

export const getLayer = (history, id) => async dispatch => {
    try {
        dispatch(setLoading());
        // Send request
        const {data} = await axiosInstance(history, dispatch).get(`/layer/${id}`);
        // Update state
        dispatch({
            type: LAYER_ACTION_TYPES.SHOW_LAYER,
            payload: data
        });
        return data;
    } catch (err) {
        console.log(err);
        dispatch({
            type: LAYER_ACTION_TYPES.ERROR_LAYER,
            payload: err.message
        });
    }
};

export const editLayer = (history, id, layer, setLayerCreated) => async dispatch => {
    try {
        dispatch(setLoading());
        // Send request and get data
        const {data} = await axiosInstance(history, dispatch).patch(`/layer/${id}`, layer);
        // Update state
        dispatch({
            type: LAYER_ACTION_TYPES.EDIT_LAYER,
            payload: data
        });
        setLayerCreated(true);
    } catch (err) {
        console.log(err);
        const error = await err.response.data;
        dispatch({
            type: LAYER_ACTION_TYPES.ERROR_LAYER,
            payload: error
        });
    }
};

export const deleteLayer = (history, id) => async dispatch => {
    try {
        dispatch(setLoading());
        // Send request
        await axiosInstance(history, dispatch).delete(`/layer/${id}`);
        // Update state
        dispatch({
            type: LAYER_ACTION_TYPES.DELETE_LAYER,
            payload: id
        });
    } catch (err) {
        console.log(err);
        dispatch({
            type: LAYER_ACTION_TYPES.ERROR_LAYER,
            payload: err.message
        });
    }
};
